import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from "react-router"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Loading from 'components/Loading'
import Block from 'components/common/Block'
import Footer from 'components/common/Footer'
import ResultBlock from 'components/common/ResultBlock'
import OrderItemList from 'components/common/OrderItemList'

import { formatNumber, receiptTypeEnum } from 'libraries/utils'

import { orderCreditCardPayment } from '../../actions/asyncOrders'
import {
	cleanOrderCreditCardPaymentResult
} from '../../actions/orders'

const ListFiedGrid = props => (
	<Grid container className="list-item">
		<Grid item xs={2}>
			<Typography className="text-grey">{props.title}</Typography>
		</Grid>
		<Grid item xs={10}>
			{props.children}
		</Grid>
	</Grid>
)

const PaymentComfirm = props => {
	const { t } = useTranslation();
	const { isLoading, memberInfo, succUpdatedOrder,
		orderCreditCardPaymentSucc, orderCreditCardPaymentFail,
		cleanOrderCreditCardPaymentResult,
	} = props
	const orderId = props.location.state
	const [paymentResult, setPaymentResult] = useState(null)

	useEffect(() => {
		// component did mount
		// no orderId go back to inbound list
		if(!orderId || succUpdatedOrder.size === 0) {
			goBack()
		}

		window.scrollTo(0, 0)

		// component will unmount
		return () => {
			cleanOrderCreditCardPaymentResult()
		}
	}, [])

	const receiptType = succUpdatedOrder.getIn(['receipt', 'type'])
	const receiptTitle = succUpdatedOrder.getIn(['receipt', 'title'])
	const receiptTaxId = succUpdatedOrder.getIn(['receipt', 'taxId '])

	const goBack = () => {
		props.history.push('/member/inbound/detail', orderId)
	}

	const onConfirm = () => {
		props.orderCreditCardPayment(orderId) // orderId, data
	}

	useEffect(() => {
		if(orderCreditCardPaymentSucc) {
			setPaymentResult('succ')
		}
	}, [orderCreditCardPaymentSucc])

	useEffect(() => {
		if(orderCreditCardPaymentFail) {
			setPaymentResult('fail')
		}
	}, [orderCreditCardPaymentFail])

	const goOrderList = () => {
		props.history.push('/member/order')
	}

	if (paymentResult === 'succ') {
		return (
			<Grid container justify="center" style={{ marginTop: '20vh' }}>
				<ResultBlock
					status="succ"
					onClick={goOrderList}
					title={t('payment_status_paid')}
					msg={'當系統完成酒標辨識後，您可以在<br/>藏酒列表中管理您的愛酒並查看國際價格'}
				/>
			</Grid>
		)
	}

	if (paymentResult === 'fail') {
		return (
			<Grid container justify="center" style={{ marginTop: '20vh' }}>
				<ResultBlock
					onClick={goOrderList}
					title={t('patment_status_failed')}
					msg={'出了一點差錯，別擔心！<br/>稍後您可以從訂單記錄中重新付款'}
				/>
			</Grid>
		)
	}

	return (
		<Grid container justify="center" className="main-contaienr payment-comfirm">
			<Loading isLoading={isLoading} />
			<Grid item md={8}>
				<Grid container>
					<Typography variant="h1">
						{t('inbound_fee_comfirm')}
					</Typography>
				</Grid>
				<Block
					title={t('credit_card_setting')}
					contClassname="bg-white payment-detail"
				>
					<ListFiedGrid
						title={t('receipt_info')}
					>
						<Typography>{receiptTypeEnum[receiptType]}</Typography>
						{receiptType === parseInt(receiptTypeEnum.THREE_LINE) &&
							<Grid>
								<Typography className="text-grey">
									{t('receipt_title')}：{receiptTitle}
								</Typography>
								<Typography className="text-grey">
									{t('tax_id')}：{receiptTaxId}
								</Typography>
							</Grid>
						}
					</ListFiedGrid>
					<ListFiedGrid
						title={t('payment_method')}
					>
						<Typography>
							{t('credit_card')} ···· ···· ···· {memberInfo.creditCardLastFour}
						</Typography>
					</ListFiedGrid>
					<ListFiedGrid
						title={t('inbound_item')}
					>
						<Typography>{succUpdatedOrder.get('totalBottle')} {t('bottle')}</Typography>
					</ListFiedGrid>
					{/* <ListFiedGrid
						title={t('use_coupon')}
					></ListFiedGrid> */}
					<ListFiedGrid
						title={t('total_fee')}
					>
						<Typography color="primary" variant="h1">
							{formatNumber(succUpdatedOrder.get('amount'))}
							<span style={{ fontSize: '16px', color: '#4a4f55', paddingLeft: '5px' }}>
								{t('currency_unit')}
							</span>
						</Typography>
					</ListFiedGrid>
				</Block>

				{/* footer */}
				<Footer />

				<Grid container justify="flex-end" style={{ marginTop: '20px' }}>
					<Button variant="outlined" style={{ marginRight: '20px' }} onClick={goBack}>
						{'返回入窖明細'}
					</Button>
					<Button variant="contained" color="primary" onClick={onConfirm}>
						{t('payment_comfirm')}
					</Button>
				</Grid>

				<Block title={t('inbound_detail')}>
					<OrderItemList
						orderId={orderId}
					/>
				</Block>
			</Grid>
		</Grid>
	)
}

const mapStateToProps = state => ({
	memberInfo: state.member.member,
	succUpdatedOrder: state.orders.succUpdatedOrder,
	orderCreditCardPaymentSucc: state.orders.orderCreditCardPaymentSucc,
	orderCreditCardPaymentFail: state.orders.orderCreditCardPaymentFail,
})

const mapDispatchToProps = {
	orderCreditCardPayment,
	cleanOrderCreditCardPaymentResult,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(PaymentComfirm))
